/* Auto Generated */

export enum Deployment {
	singleUser,
	multiUser,
	unknown,
}
